import React from 'react';
import { IconCaretDownNoRadius } from '../../../assets/icons';
import { UserState } from '../../../types/user.store.type';
import languages from '../../../assets/languages.json';
import { TranslationUtils, ValidationUtils } from '../../../utils';

interface RightMobileNavMenuProps {
    user: UserState;
    currency: string;
    language: string;
    onLogin: () => void;
    onLogout: () => void;
    onLanguageChange: (e: any) => void;
    onCurrencyChange: (e: any) => void;
    updateLanguageInputWidth: () => void;
    updateCurrencyInputWidth: () => void;
}

export const RightMobileNavMenu: React.FC<RightMobileNavMenuProps> = (props) => {
    const { user, language, onLogin, onLogout, onLanguageChange, updateLanguageInputWidth, updateCurrencyInputWidth } = props;
    const vacasaUrl = ValidationUtils.validateAndGetEnvVar('REACT_APP_VACASA_URI');
    const ownerPortalURL = process.env['REACT_APP_OWNER_PORTAL_URL'];
    updateLanguageInputWidth();
    updateCurrencyInputWidth();

    return (
        <div id="sidenavbar-right" className="sidenavbar right-inactive fixed-top d-lg-none">
            <div className="sidenavbar-content nav-font-mobile pt-3">
                {user.user ? (
                    <React.Fragment>
                        <div className="mx-2 account-name">
                            {TranslationUtils.get('hi')}
                            {user.user.name}
                        </div>
                        <div className="mx-32">
                            <a id="navbar-trip-mobile" className="sidenavbar-item" href={`${vacasaUrl}/my-trips`}>
                                <span>{TranslationUtils.get('my_trips')}</span>
                            </a>
                            <a id="navbar-favorites-mobile" className="sidenavbar-item" href={`${vacasaUrl}/favorites`}>
                                <span>{TranslationUtils.get('favorites')}</span>
                            </a>
                            <a id="navbar-profile-mobile" className="sidenavbar-item" href={`${vacasaUrl}/my-profile`}>
                                <span>{TranslationUtils.get('profile')}</span>
                            </a>
                        </div>
                        <div className="sidenavbar-divider" />
                        <div className="mx-32">
                            <a id="navbar-owner-login-mobile" href={`${ownerPortalURL}/login`} className="sidenavbar-item">
                                <span>{TranslationUtils.get('owner_portal')}</span>
                            </a>
                        </div>
                        <div className="sidenavbar-divider" />
                        <div className="mx-32">
                            <a id="navbar-favorites-mobile" className="sidenavbar-item" href="#/" onClick={onLogout}>
                                <span>{TranslationUtils.get('logout')}</span>
                            </a>
                        </div>
                    </React.Fragment>
                ) : (
                    <React.Fragment>
                        <div className="mx-2">{TranslationUtils.get('my_account')}</div>
                        <div className="mx-32 mr-32">
                            <a id="navbar-owner-login-mobile" href={`${ownerPortalURL}/login`} className="sidenavbar-item">
                                <span>{TranslationUtils.get('owner_login')}</span>
                            </a>
                            <a id="navbar-login-mobile" className="sidenavbar-item" href="#/" onClick={onLogin}>
                                <span>{TranslationUtils.get('login')}</span>
                            </a>
                        </div>
                    </React.Fragment>
                )}
                <div className="sidenavbar-divider" />
                <div className="mx-2 pl-1">{TranslationUtils.get('language_and_currency')}</div>
                <div className="mx-32 mt-2">
                    <div className="language-currency-dropdown sidenavbar-select-border">
                        <select
                            id="language-link-mobile"
                            className="sidenavbar-item collapse-toggle d-flex sidenavbar-select nav-font-mobile"
                            onChange={onLanguageChange}
                            value={language}
                        >
                            {languages.map((languageOption, index) => {
                                return (
                                    <option key={index} value={languageOption.code} className={'nav-font-mobile'}>
                                        {languageOption.name}
                                    </option>
                                );
                            })}
                        </select>
                        <IconCaretDownNoRadius className="icon-caret-down-nav-v2 mb-2" />
                    </div>
                </div>
            </div>
        </div>
    );
};
